import { z } from 'zod';
import { ExamModeSchema } from './common.js';

// Запит на старт нової спроби
export const StartAttemptSchema = z.object({
  mode: ExamModeSchema.default('CATEGORY'),
  categoryId: z.number().int().positive().optional(),
});
export type StartAttemptInput = z.infer<typeof StartAttemptSchema>;

// Подача відповіді на питання
export const SubmitAnswerSchema = z.object({
  questionId: z.number().int().positive(),
  answerId: z.number().int().positive().nullable(),
  timeMs: z.number().int().nonnegative().max(600_000), // не більше 10 хв на питання
});
export type SubmitAnswerInput = z.infer<typeof SubmitAnswerSchema>;
